module.exports = __webpack_public_path__ + "static/media/Lambda_Logo_white.475fdb35.png";